// extracted by mini-css-extract-plugin
module.exports = {"autoSuggetionWrapper":"v1_autoSuggetionWrapper__CXP_L"};